const items = [
  "Cheesesteaks at 3AM",
  "Warehouse Sound Systems",
  "Rooftop Vinyl Sessions",
  "Secret Speakeasies",
  "First Friday Gallery Runs",
  "South Street Neon",
  "Tickets Selling Fast",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div className="overflow-hidden border-y border-white/10 bg-[#0E1117] py-4" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 font-editorial text-lg uppercase tracking-wider text-zinc-600">
            {item}
            <span className="text-neon-lime">//</span>
          </span>
        ))}
      </div>
    </div>
  );
}
